// extracted by mini-css-extract-plugin
export default {"modalBody":"FeatureModal_modalBody__Oamvx"};